/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  PlatformSettingsResponseDto,
  UpdatePlatformSettingsDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Get the platform-wide settings currently in force
 */
export const getPlatformSettingsQueryControllerGet = (signal?: AbortSignal) => {
  return axiosClient<PlatformSettingsResponseDto>({
    url: `/v1/platform-settings`,
    method: "GET",
    signal,
  });
};

export const getGetPlatformSettingsQueryControllerGetQueryKey = () => {
  return [`/v1/platform-settings`] as const;
};

export const getGetPlatformSettingsQueryControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformSettingsQueryControllerGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>
  > = ({ signal }) => getPlatformSettingsQueryControllerGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlatformSettingsQueryControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>
>;
export type GetPlatformSettingsQueryControllerGetQueryError = void;

export function useGetPlatformSettingsQueryControllerGet<
  TData = Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlatformSettingsQueryControllerGet<
  TData = Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlatformSettingsQueryControllerGet<
  TData = Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the platform-wide settings currently in force
 */

export function useGetPlatformSettingsQueryControllerGet<
  TData = Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformSettingsQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetPlatformSettingsQueryControllerGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the platform-wide settings (platform admin only)
 */
export const updatePlatformSettingsCommandControllerUpdate = (
  updatePlatformSettingsDto: UpdatePlatformSettingsDto,
  signal?: AbortSignal,
) => {
  return axiosClient<PlatformSettingsResponseDto>({
    url: `/v1/platform-settings`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updatePlatformSettingsDto,
    signal,
  });
};

export const getUpdatePlatformSettingsCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlatformSettingsCommandControllerUpdate>>,
    TError,
    { data: UpdatePlatformSettingsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlatformSettingsCommandControllerUpdate>>,
  TError,
  { data: UpdatePlatformSettingsDto },
  TContext
> => {
  const mutationKey = ["updatePlatformSettingsCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlatformSettingsCommandControllerUpdate>>,
    { data: UpdatePlatformSettingsDto }
  > = (props) => {
    const { data } = props ?? {};

    return updatePlatformSettingsCommandControllerUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlatformSettingsCommandControllerUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updatePlatformSettingsCommandControllerUpdate>>
  >;
export type UpdatePlatformSettingsCommandControllerUpdateMutationBody =
  UpdatePlatformSettingsDto;
export type UpdatePlatformSettingsCommandControllerUpdateMutationError = void;

/**
 * @summary Update the platform-wide settings (platform admin only)
 */
export const useUpdatePlatformSettingsCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlatformSettingsCommandControllerUpdate>>,
      TError,
      { data: UpdatePlatformSettingsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlatformSettingsCommandControllerUpdate>>,
  TError,
  { data: UpdatePlatformSettingsDto },
  TContext
> => {
  return useMutation(
    getUpdatePlatformSettingsCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
